<template>
  <section class="section">
    <div class="container">
      <!-- Possible switch to form instead of div to allow submit with Enter -->
      <div class="box">
        <!-- Add form validation and DOM binding -->
        <div class="columns">
          <div class="column is-7">
            <div class="field">
              <label class="label">Nome</label>
              <div class="control has-icons-left">
                <input
                  class="input"
                  type="text"
                  placeholder="Ex.: Associação de Estudantes do ISEP"
                />
                <span class="icon is-small is-left">
                  <i class="fas fa-user"></i>
                </span>
              </div>
            </div>

            <div class="columns">
              <div class="column is-9">
                <div class="field">
                  <label class="label">Morada</label>
                  <div class="control has-icons-left">
                    <input
                      class="input"
                      type="text"
                      placeholder="Ex.: R. Dr. António Bernardino de Almeida 431"
                    />
                    <span class="icon is-small is-left">
                      <i class="fas fa-map-marker-alt"></i>
                    </span>
                  </div>
                </div>
              </div>

              <div class="column">
                <div class="field">
                  <label class="label">Código Postal</label>
                  <div class="columns is-vcentered">
                    <div class="column is-6">
                      <div class="control">
                        <input class="input" type="text" />
                      </div>
                    </div>
                    <span><strong>-</strong></span>
                    <div class="column is-5">
                      <div class="control">
                        <input class="input" type="text" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="field">
              <label class="label">E-mail</label>
              <div class="control has-icons-left">
                <input
                  class="input"
                  type="text"
                  placeholder="Ex.: xxx@isep.ipp.pt"
                />
                <span class="icon is-small is-left">
                  <i class="fas fa-envelope"></i>
                </span>
              </div>
            </div>
          </div>

          <div class="column">
            <div class="card">
              <div class="card-image">
                <figure class="image">
                  <img
                    src="https://bulma.io/images/placeholders/1280x960.png"
                  />
                </figure>
              </div>
            </div>

            <div class="file has-name is-centered">
              <label class="file-label">
                <input class="file-input" type="file" name="resume" />
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fas fa-upload"></i>
                  </span>
                  <span class="file-label">Choose a file…</span>
                </span>
                <span class="file-name"> Teste </span>
              </label>
            </div>
          </div>
        </div>

        <!-- button example with dialog and toast -->
        <!-- not sure if privacy policy is necessary yet -->
        <button class="button is-link" v-on:click="showPrivacyPolicy">
          Política de Privacidade
        </button>

        <!-- Button to submit should be unavailable if
        form is invalid (validation needed in js) 
        
        :disabled - property to disable button based on method/variable -->
        <div class="is-block has-text-centered">
          <button class="button is-primary" v-on:click="exampleFunc">
            Finalizar Registo
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// Required dependency for contentful-management is not functional
// as of this moment, will look at it later

/* const contentful = require("contentful-management");

const client = contentful.createClient({
  space: "7lnt6blrx994",
  accessToken: "CFPAT-gj1FdJ-uNKgGau6QsQ0c9RXfgKNcx5HyvCRC7mH1I8c",
}); */

export default {
  name: "register",
  data() {
    return {
      name: "ISEP",
      address: "TESTE",
      zipCode: "TESTE",
      email: "TESTE",
    };
  },
  methods: {
    exampleFunc: function (event) {
      alert("Hello " + this.name + "!" + event.type);
    },
    showPrivacyPolicy: function () {
      this.$dialog.confirm({
        title: "Privacy Politics",
        message: `Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Fusce id fermentum quam. Proin sagittis,
                        nibh id hendrerit imperdiet, elit sapien laoreet elit,
                        ac scelerisque diam velit in nisl. Nunc maximus ex non
                        laoreet semper. Nunc scelerisque, libero sit amet pretium dignissim,
                        augue purus placerat justo,
                        sit amet porttitor dui metus in nisl.
                        Nulla non leo placerat, porta metus eu, laoreet risus.
                        Etiam lacinia, purus eu luctus maximus, elit ex viverra tellus,
                        sit amet sodales quam dui nec odio.
                        Nullam porta mollis est. Quisque aliquet malesuada fringilla.
                        Pellentesque volutpat lacus at ante posuere,
                        non pulvinar ante porta. Proin viverra eu massa nec porta.
                        Aliquam rhoncus velit quis sem hendrerit,
                        ut dictum nisl accumsan. Maecenas erat enim, scelerisque non ligula ac,
                        eleifend venenatis ligula.
                        Praesent molestie mauris sed elit posuere, non malesuada libero gravida.
                        In hac habitasse platea dictumst.
                        Pellentesque habitant morbi tristique senectus
                        et netus et malesuada fames ac turpis egestas.`,
        cancelText: "Disagree",
        confirmText: "Agree",
        type: "is-success",
        onConfirm: () => this.$toast.open("User agreed"),
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/RegisterComponent.vue